import { useState } from "react";

const faqs = [
  {
    q: "播放区域真的能看完整版电影吗？",
    a: "目前不能。全站播放区域均为前端演示模块，仅用于展示页面结构与交互位置，不包含任何真实片源或播放接口。我们也建议通过正规渠道观看正版影片。",
  },
  {
    q: "章节是怎么划分的？",
    a: "按剧情时间线拆分为序幕、铺陈、转折、高潮、尾声五个阶段，共 12 个章节。每章 8 至 18 分钟不等，标题与摘要都从叙事节点出发，方便你快速定位想看的段落。",
  },
  {
    q: "收藏的章节存在哪里？需要登录吗？",
    a: "不需要登录。收藏状态保存在你当前浏览器的本地存储中，刷新或重新打开页面仍会保留。清除浏览器数据后会一并清空，也不会同步到其他设备。",
  },
  {
    q: "站内资料与影评是官方内容吗？",
    a: "不是。站内剧情解说、影评与推荐均为本站原创整理，影片基本信息仅作示例展示，部分演职员信息为演示用虚构内容，请以官方发布为准。",
  },
];

export default function HomeFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="container-page py-14 md:py-20">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.7fr_1.3fr] lg:gap-14">
        <div>
          <div className="flex items-center gap-2">
            <span className="h-px w-8 bg-accent-500" />
            <span className="font-label text-xs tracking-[0.28em] text-accent-500">常见问题</span>
          </div>
          <h2 className="mt-3 font-heading text-2xl leading-snug text-foreground-950 md:text-[32px]">
            开始之前，
            <br className="hidden sm:block" />
            你可能会想知道
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于播放、章节划分与收藏机制的说明都放在这里。如果还有其他问题，可以在关于页留下反馈。
          </p>
        </div>

        <div className="divide-y divide-background-200 border-y border-background-200">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
                >
                  <h3 className={`font-heading text-sm transition-colors md:text-base ${open ? "text-accent-400" : "text-foreground-900"}`}>
                    {item.q}
                  </h3>
                  <i
                    className={`${
                      open ? "ri-subtract-line" : "ri-add-line"
                    } shrink-0 text-lg leading-none text-accent-500`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    open ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="pb-5 pr-8 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}